import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { CheckHasRestrictionsRequest } from '../../requests/private-billing/check-has-restriction.request';
import { CheckHasRestrictionResponse } from '../../responses/billing/check-has-restriction.response';

@Injectable({
  providedIn: 'root'
})
export class CheckHasRestrictionService extends CommonService {
  constructor(private httpClient: HttpClient) { super(); }

  GetListEpisodeByIdPatient(body: CheckHasRestrictionsRequest): Observable<CheckHasRestrictionResponse> {
    let uri = `CheckHasRestriction`

    return this.httpClient.post<CheckHasRestrictionResponse>(environment.urlApiOrchestratorBilling + uri, body, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}